import React from 'react';
import { FileText } from 'lucide-react';
import { PageHeader } from '../components/common/PageHeader';
import { ReportDocument } from '../components/ai/ReportDocument';
import { EmptyState } from '../components/common/EmptyState';
import { usePlatform } from '../contexts/PlatformContext';
import { reportTypeLabels } from '../utils/reportBuilder';
import { formatDate } from '../utils/format';
import { cn } from '../utils/cn';
export function Reports() {
  const {
    reports
  } = usePlatform();
  const [selectedId, setSelectedId] = React.useState(reports[0]?.id ?? '');
  const selected = reports.find(report => report.id === selectedId) ?? reports[0];
  return <div data-id="element-1197" data-mp="1uxaq4gm07qrv">
      <PageHeader eyebrow="Intelligence" title="Reports archive" description="Every report generated by the intelligence hub, with its type, scope, period and audience." data-id="element-1198" data-mp="1uxk9vmggh1p4" />

      {reports.length === 0 ? <div className="p-6" data-id="element-1199" data-mp="29rp5862g6g19">
          <EmptyState title="No reports generated" description="Generate a report from the AI intelligence hub and it will be archived here." icon={FileText} data-id="element-1200" data-mp="29t08m4rzdlru" />
        </div> : <div className="grid gap-4 p-6 xl:grid-cols-[360px_1fr]" data-id="element-1201" data-mp="25wk9e46n10l4">
          <nav aria-label="Generated reports" className="space-y-2" data-id="element-1202" data-mp="25x2bhhfze90y">
            {reports.map(report => <button key={report.id} type="button" onClick={() => setSelectedId(report.id)} aria-current={selected?.id === report.id} className={cn('w-full rounded-sm border px-3 py-2.5 text-left transition-colors', selected?.id === report.id ? 'border-uae-green bg-uae-green text-white' : 'border-border bg-card hover:bg-muted')} data-id="element-1203" data-mp="21x1pnbqjyvjv">
                <p className="text-[13px] font-medium leading-snug" data-id="element-1204" data-mp="3cl0pa661aqbx">{report.title}</p>
                <p className={cn('mt-0.5 text-[11px]', selected?.id === report.id ? 'text-white/70' : 'text-muted-foreground')} data-id="element-1205" data-mp="3cj61mk3dok45">
                  {reportTypeLabels[report.type]} · {report.period}
                </p>
                <p className={cn('mt-0.5 text-[11px]', selected?.id === report.id ? 'text-white/70' : 'text-muted-foreground')} data-id="element-1206" data-mp="15wqhsg5dzah4">
                  {formatDate(report.createdOn)} · {report.audience}
                </p>
              </button>)}
          </nav>

          {selected && <ReportDocument report={selected} data-id="element-1207" data-mp="i0vzb2wjpjd0" />}
        </div>}
    </div>;
}